import { AuthorizedSenderEmailAddressDTO } from "../DTO/authorizedSenderEmailAddressDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateAuthorizedSenderEmailAddressRequest extends BasicRequest{

    public authorizedSenderEmailAddress! : AuthorizedSenderEmailAddressDTO;

    constructor(){
        super();
    }

}